import { Link } from 'react-router-dom';
import { useState } from 'react';
import logo from '../assets/logo1.png';

function Header() {

  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="header">

      <div className="header-container">

        {/* LOGO */}
        <Link to="/" onClick={() => window.location.reload()}>
          <img src={logo} alt="logo" className="header-logo" />
        </Link>

        {/* BOTON HAMBURGUESA */}
        <div
          className={`hamburger ${menuOpen ? "active" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>

        {/* NAV */}
        <nav className={`header-nav ${menuOpen ? "open" : ""}`}>

          <Link to="/" onClick={() => setMenuOpen(false)}>
            Inicio
          </Link>

          <Link to="/destinos" onClick={() => setMenuOpen(false)}>
            Destinos
          </Link>

          <Link to="/contacto" onClick={() => setMenuOpen(false)}>
            Contáctanos
          </Link>

          <Link to="/galeria" onClick={() => setMenuOpen(false)}>
            Galería
          </Link>

          <Link to="/nosotros" onClick={() => setMenuOpen(false)}>
            Nosotros
          </Link>

        </nav>

        {/* BOTÓN RESERVA */}
        <a
          href="https://wa.me/c/51935438935"
          className="header-reserva"
        >
          <span className="reserva-texto">ver catálogo</span>
          <span className="reserva-numero">Preciona Aquí</span>
        </a>

      </div>

    </header>
  );
}

export default Header;